module.exports = __webpack_public_path__ + "static/step-one@2x-fb1e78de6f74a3a92a6b133f722a3c66.png";